export default "__VITE_ASSET__af130ee6__"